import { ZodError } from 'zod';

// eslint-disable-next-line @typescript-eslint/ban-types
export const flattenZodErrors = (error: ZodError<{}> | undefined | null) =>
  error?.flatten((issue) => issue) ?? null;
